import Phaser from 'phaser';
import { gameConfig } from './config/GameConfig';
import { setTelemetryConsent, trackAppLoaded } from './systems/Telemetry';
import { initAds } from './systems/Ads';
import { initPrivacyControls } from './systems/Privacy';

/**
 * The game is designed at a fixed 1280x720 landscape resolution (see
 * ASSET.md section 1) — every scene lays out UI against that aspect ratio.
 * Rather than squeeze into an unplayable sliver on a portrait phone, show a
 * rotate prompt and let the canvas resume once the device is landscape.
 */
const rotatePrompt = document.getElementById('rotate-prompt');

function updateOrientation(): void {
  if (!rotatePrompt) return;
  const isPortrait = window.innerHeight > window.innerWidth;
  rotatePrompt.style.display = isPortrait ? 'flex' : 'none';
}

updateOrientation();
window.addEventListener('resize', updateOrientation);
window.addEventListener('orientationchange', updateOrientation);

const game = new Phaser.Game(gameConfig);

document.addEventListener('privacy-center-opened', () => {
  game.sound.pauseAll();
  game.loop.sleep();
});
document.addEventListener('privacy-center-closed', () => {
  game.loop.wake();
  game.sound.resumeAll();
});

let appLoadTracked = false;
let adsInitialized = false;
const applyPrivacyChoice = (analyticsAllowed: boolean): void => {
  setTelemetryConsent(analyticsAllowed);
  if (analyticsAllowed && !appLoadTracked) {
    appLoadTracked = true;
    trackAppLoaded();
  }
  if (!adsInitialized) {
    adsInitialized = true;
    initAds();
  }
};

const initialConsent = initPrivacyControls(applyPrivacyChoice);
if (initialConsent !== 'unset') applyPrivacyChoice(initialConsent === 'granted');
